import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {UserSearch} from '@models/search';
import {AdService} from '@services/ad.service';
import {AuthenticationService} from '@services/authentification.service';
import {OnboardingService} from '@services/onboarding.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AlertService} from '@services/alert.service';

@Component({
  selector: 'app-dupplicate',
  templateUrl: './duplicate.component.html',
  styleUrls: ['./duplicate.component.scss']
})
export class DuplicateComponent implements OnInit {

    favoriteForm = new UntypedFormGroup({
        title: new UntypedFormControl(''),
    });
    currentSearch: UserSearch;
    loading = false;

    constructor(
        private adService: AdService,
        private authenticationService: AuthenticationService,
        private onboardingService: OnboardingService,
        private alertService: AlertService,
        public dialogRef: MatDialogRef<DuplicateComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit(): void {
        this.currentSearch = this.data.userSearch;

        this.favoriteForm = new UntypedFormGroup({
            title: new UntypedFormControl(this.currentSearch.title),
        });
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        if (this.favoriteForm.valid && this.loading == false) {
            this.loading = true
            const newUserSearch: UserSearch = {
                id: null,
                title: this.favoriteForm.get('title').value,
                search_ad_params: this.currentSearch.search_ad_params,
                frequency_alert: this.currentSearch.frequency_alert,
                price_alert: this.currentSearch.price_alert,
            };

            this.adService.addUserSearch(newUserSearch).subscribe((us) => {
                this.dialogRef.close({currentSearch: us});
            }, error => {
                this.alertService.error('une erreur est survenue, veuillez réessayer ou nous contacter si le problème persiste.');
                console.log(error);
                this.loading = false
            });
        }
    }
}

